/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_Admin_HintInputs */

const cs_sreality_seller_admin_hint = /** @type {(inputs: Sreality_Seller_Admin_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Založí tohoto člověka jako makléře pod importním účtem RK. Nejdřív musí být klíče RK v Integracích. Použijte jeho Seznam.cz login — ne XML-RPC heslo RK.`)
};

const en_sreality_seller_admin_hint = /** @type {(inputs: Sreality_Seller_Admin_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creates this person as a makléř under the office RK import account. Requires the RK keys on Integrations first. Use their Seznam.cz login — not the RK XML-RPC password.`)
};

/**
* | output |
* | --- |
* | "Creates this person as a makléř under the office RK import account. Requires the RK keys on Integrations first. Use their Seznam.cz login — not the RK XML-RP..." |
*
* @param {Sreality_Seller_Admin_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_admin_hint = /** @type {((inputs?: Sreality_Seller_Admin_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_Admin_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_admin_hint(inputs)
	return cs_sreality_seller_admin_hint(inputs)
});